/* DON'T EDIT THIS FILE: edit original and run build again */ import { Empty } from "./frozen-empty-object.ts";

export function isEmptyObject<T extends object>(obj: T | Empty): obj is Empty {
  for (const _ in obj) {
    return false;
  }
  return true;
}
